import React from 'react'; //eslint-disable-line
import utils from '../utils';
import { useTranslation } from 'react-i18next';
import '../i18n';

const BusStopRows = props => {
  const detail = props.detail;
  const { t } = useTranslation();

  if (!detail || !Array.isArray(detail.stops) || detail.stops.length === 0) {
    return (
      <ul>
        <li className="bus-departure-row no-trip">{t('busDepartures.noData')}</li>
      </ul>
    );
  }

  const getExpectedTime = (stop, isTripCancelled = false) => {
    let expectedTime = stop.expectedAtFormatted;
    let expectedTimeClass = '';

    if (isTripCancelled || stop.isCancelled) {
      expectedTime = t('tripStatus.cancelled');
      expectedTimeClass = 'cancelled';
    } else if (!stop.isMajor) {
      expectedTime = '-';
    } else if (stop.isDone) {
      expectedTimeClass = 'changed';
    }

    return { expectedTime: utils.formatTime(expectedTime, props.isTwentyFourHour), expectedTimeClass };
  };

  return (
    <ul>
      {Array.isArray(detail.stops) && detail.stops.map((bus, index) => {
        const ariaLive = index === 0 ? 'assertive' : 'off';
        const trackChangedClass = bus.actualTrack !== bus.scheduledTrack ? 'changed' : '';
        const { expectedTime, expectedTimeClass } = getExpectedTime(bus, detail.isTripCancelled);
        return (
          <li key={`${bus.stopCode}`} className="bus-departure-row trip" id={index} aria-live={ariaLive}>
            <div className='data trip in-service remarks'>
              <div aria-describedby={t('busDepartures.columnHeadings.1')}>
                {bus.stopName}
              </div>
              <div className="schedule-col" aria-describedby={t('busDepartures.columnHeadings.2')}>
                {utils.formatTime(bus.scheduledAtFormatted, props.isTwentyFourHour)}
              </div>
              <div aria-describedby={t('busDepartures.columnHeadings.3')}>
                {bus.isDone ? (
                  <div><i className="far fa-check" /></div>
                ) : (
                  <div>
                    <div className={`track ${trackChangedClass}`}>{bus.actualTrack}</div>
                  </div>
                )}
              </div>
              <div className={`schedule-col ${expectedTimeClass}`} aria-describedby={t('busDepartures.columnHeadings.4')}>
                {bus.isDone ? t('tripStatus.departed') : expectedTime}
              </div>
            </div>
          </li>
        );
      })}
    </ul>
  );
};

export default BusStopRows;
